import { Link } from 'react-router-dom'
import { REP_GAPS } from '@/lib/repGaps'

/** "Filtered by: <gap> · <rep>" with a link back to the unfiltered list. */
export function GapFilterBanner({
  gap,
  clearTo,
  ownerName,
}: {
  gap?: string
  clearTo: string
  ownerName?: string
}) {
  if (!gap || !REP_GAPS[gap]) return null
  return (
    <div className="mt-2 flex items-center gap-2" role="status">
      <span className="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full font-medium">
        Filtered by: {REP_GAPS[gap].label}
        {ownerName ? ` · ${ownerName}` : ''}
      </span>
      <Link to={clearTo} className="text-sm text-muted-foreground hover:text-foreground underline">
        Clear filter
      </Link>
    </div>
  )
}
